import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function Today() {
  const links = useSelector((state) => state.links);
  const [errors, setErrors] = useState([]);
  useEffect(() => {
    setErrors(new Array(links.length).fill(false));
  }, [links]);
  const setError = (index) => {
    console.log("Error", index);
    setErrors((ers) =>
      ers.map((e, i) => {
        if (i === index) {
          return true;
        }
        return e;
      })
    );
  };

  const getPreview = (link, index) => {
    return (
      <div style={{ fontSize: "8px", paddingLeft: "4px", paddingRight: "4px" }}>
        <img
          src={
            link.img && link.img.length > 0
              ? link.img
              : errors[index]
              ? "http://cdn.onlinewebfonts.com/svg/img_504359.png"
              : `${link.url}/favicon.ico`
          }
          onError={(e) => {
            setError(index);
          }}
          style={{
            display: "block",
            width: "30px",
            height: "30px",
            cursor: "pointer",

            marginLeft: "auto",
            marginRight: "auto",
          }}
          onClick={() => window.open(link.url)}
        />
        <div style={{ textAlign: "center" }}>{link.name}</div>
      </div>
    );
  };
  return (
    <div style={{ fontSize: 30 }}>
      <div>{moment().format("dddd MMM Do")}</div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {links.map((l, i) => getPreview(l, i))}
      </div>
    </div>
  );
}
